import React from "react";

interface CheckmarkIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  color?: string;
}

export const CheckmarkIcon: React.FC<CheckmarkIconProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5L6.5 9.5L14 2"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
